import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'forcepositivesign',
})
export class ForcePositiveSign implements PipeTransform {
  transform(value: number): string {
    if (value === undefined || value == null) {
      return '';
    }

    if (value > 0) {
      return '+' + String(value);
    } else {
      return String(value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_pipes/forcepositivesign.pipe.ts